import baseAPI from '@/api/base';
import {
  EditKabbalah_N,
  GetKabbalah_N,
  GetKabbalahDisplay_N,
  GetKabbalahStats_N,
  RegisterKabbalah_N,
  SaveKabbalahDisplayDestination_N,
} from '@/dtos/kabbalah_N.dto';
import {
  APPROVE_KABBALAH_N_URL,
  DELETE_KABBALAH_N_URL,
  EDIT_KABBALAH_DISPLAY_URL,
  EDIT_KABBALAH_N_URL,
  GET_KABBALAH_N_DISPLAY_URL,
  GET_KABBALAH_N_STATS_URL,
  GET_KABBALAH_N_URL,
  MARK_VIEWED_KABBALAH_N_URL,
  REGISTER_KABBALAH_N_URL,
  REJECT_KABBALAH_N_URL,
  TOGGLE_KABBALAH_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Kabbalah_N {
  static getKabbalahDisplay_N = async (
    payload: GetKabbalahDisplay_N
  ): Promise<AxiosResponse> => {
    return baseAPI.get(GET_KABBALAH_N_DISPLAY_URL, {
      params: payload,
    });
  };

  static getKabbalahs_N = async (
    getKabbalah_N: GetKabbalah_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_KABBALAH_N_URL, {
      params: getKabbalah_N,
    });
    return response;
  };

  static getKabbalahStats_N = async (
    getKabbalahStats_N: GetKabbalahStats_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_KABBALAH_N_STATS_URL, {
      params: getKabbalahStats_N,
    });
    return response;
  };

  static registerKabbalah_N = async (
    payload: RegisterKabbalah_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_KABBALAH_N_URL, {
      ...payload,
    });
    return response;
  };

  static editKabbalah_N = async (
    payload: EditKabbalah_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_KABBALAH_N_URL, {
      ...payload,
    });
    return response;
  };

  static toggleKabbalah_NIsActive = async (
    payload: Pick<EditKabbalah_N, 'id'>
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_KABBALAH_N_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static approveKabbalah_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${APPROVE_KABBALAH_N_URL}/${id}`
    );
    return response;
  };

  static rejectKabbalah_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${REJECT_KABBALAH_N_URL}/${id}`
    );
    return response;
  };

  static markViewedKabbalah_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${MARK_VIEWED_KABBALAH_N_URL}/${id}`
    );
    return response;
  };

  static deleteKabbalah_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_KABBALAH_N_URL}/${id}`
    );
    return response;
  };

  // The one organization-wide destination every approved record is shown in.
  // Lives on the organization rather than on a record, so it is saved through
  // its own endpoint rather than with the record.
  static saveKabbalahDisplayDestination = async (
    payload: SaveKabbalahDisplayDestination_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      EDIT_KABBALAH_DISPLAY_URL,
      {
        ...payload,
      }
    );
    return response;
  };
}

export default Kabbalah_N;
